<template>
    <hang-tags msg="Etiquetas"/>
</template>
<script>
import HangTags from "../../components/admin/HangTags.vue"

export default {
    components: { HangTags }
}
</script>